import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { cn, findKeyFromUrl, findPageNameFromUrl } from '../lib/utils';
import AppSideMenu from '../components/nav/AppSideMenu';
import { useSideNavStore } from '../store';
import AppHeader from '../components/nav/AppHeader';
import { items } from '../components/nav/SideMenuItems';

function App() {
  const location = useLocation();
  const sideNav = useSideNavStore();

  useEffect(() => {
    if (location.pathname == null) sideNav.setSelectedKey('/');
    // A page with its own sub-routes (Planning: /production/planning/setup)
    // is listed in the menu by its base url; fall back to the parent path only
    // when the exact path matches nothing.
    const parent = location.pathname.replace(/\/[^/]+\/?$/, '');
    sideNav.setSelectedKey(
      findKeyFromUrl(items, location.pathname) || findKeyFromUrl(items, parent),
    );
    sideNav.setSelectedPage(
      findPageNameFromUrl(items, location.pathname) ||
        findPageNameFromUrl(items, parent),
    );
  }, [location.pathname]);

  return (
    <>
      <Layout className={'min-h-screen'}>
        <AppSideMenu />
        <Layout
          className={cn('h-full', sideNav.isCollapse ? 'ml-20' : 'ml-64')}
        >
          <AppHeader />
          <div className={'p-4'}>
            <Outlet />
          </div>
        </Layout>
      </Layout>
    </>
  );
}

export default App;
